<ngx-ui-loader fgsColor="#570dbf"
               fgsPosition="center-center"
               fgsType="ball-spin-clockwise"
               text="Realizando acción..."
               hasProgressBar="false">
</ngx-ui-loader>
<router-outlet></router-outlet>
